import React, { Component } from 'react';
import FilterBasic from '../../basicElement/FilterBasic';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';

class Filter extends Component {
    state = {
        areaOptions: [],
        diseaseOptions: [],
        businessList: [],
    }

    componentDidMount() {
        this.loadAreaList();
        this.queryWithLevelByParams();
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryAllInvestigationArea,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const areaOptions = (res.data || []).map(item => {
                const { investigationAreaId, investigationAreaName } = item;
                return {
                    label: investigationAreaName,
                    value: investigationAreaId,
                };
            });
            this.setState({ areaOptions });
        });
    }

    loadDiseaseList = (investigationAreaId) => {
        if (!investigationAreaId) return;
        const options = {
            method: 'POST',
            url: API_URL.common.queryAllDisease,
            data: { investigationAreaId },
            dataType: 'json',
            doneResult: res => {
                const diseaseOptions = (res.data || []).map(item => {
                    const { diseaseId, diseaseName } = item;
                    return {
                        value: diseaseId,
                        label: diseaseName,
                    };
                });
                this.setState({ diseaseOptions });
            }
        };
        $.sendRequest(options);
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    handleChange = (params, key) => {
        if (key === 'investigationAreaId') {
            params.diseaseId = undefined;
            this.props.onChange(params, key);
            this.loadDiseaseList(params['investigationAreaId']);
        } else if (key === 'lineOfBusiness') {
            params.secondLineName = undefined;
            this.props.onChange(params, key);
        } else {
            this.props.onChange(params, key);
        }
    }

    getOptions = (list) => {
        return (list || []).map(i => ({ label: i.optionValue, value: i.majorConfigureId }));
    }

    render() {
        const { config, onChange, ...rest } = this.props;
        const { areaOptions, diseaseOptions, businessList } = this.state;
        const { params } = rest;
        const { invState } = sessionStorage;
        const { lineOfBusiness } = params;
        const isCenter = invState == 1;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const secondLineOption = [...secondLineSet].map(i => ({ value: i, label: i }));
        const filters = [{
            name: '重大事件编号',
            key: 'primaryEventNumber',
            type: 'input',
        }, {
            name: '重大事件单号',
            key: 'majorEventNumber',
            type: 'input',
        }, {
            name: '报告类型',
            key: 'reportType',
            type: 'select',
            typeProperty: {
                list: [
                    { label: '首次报告', value: 'FIRST_REPORT' },
                    { label: '总结报告', value: 'SUMMARY_REPORT' },
                ]
            }
        }];
        if (!isCenter) {
            filters.push({
                name: '项目简称',
                key: 'investigation',
                type: 'searchRetrieve',
                typeProperty: {
                    keyword: 'investigationName',
                    style: {width: 160},
                    placeholder: '输入名称检索',
                    params: {limit: 20},
                    url: API_URL.investigation.queryInvestigationByName,
                    config: { id: 'investigationId', name: 'investigationName' }
                }
            }, {
                name: '方案编号',
                key: 'investigationCode',
                type: 'input',
            }, {
                name: '项目领域',
                key: 'investigationAreaId',
                type: 'select',
                typeProperty: {
                    list: areaOptions,
                }
            }, {
                name: '疾病',
                key: 'diseaseId',
                type: 'select',
                typeProperty: {
                    list: diseaseOptions,
                    disabled: !params['investigationAreaId'],
                }
            }, {
                name: '申办方',
                key: 'investigationSponsor',
                type: 'searchRetrieve',
                typeProperty: {
                    keyword: 'customerCompanyName',
                    style: {width: 160},
                    placeholder: '输入名称检索',
                    params: {limit: 20, natureName: '申办方'},
                    url: API_URL.investigation.queryCustomerCompanyByName,
                    config: { id: 'customerCompanyId', name: 'customerCompanyName' }
                }
            }, {
                name: 'CRO',
                key: 'cro',
                type: 'searchRetrieve',
                typeProperty: {
                    keyword: 'customerCompanyName',
                    style: {width: 160},
                    placeholder: '输入名称检索',
                    params: {limit: 20, natureName: 'CRO'},
                    url: API_URL.investigation.queryCustomerCompanyByName,
                    config: { id: 'customerCompanyId', name: 'customerCompanyName' }
                }
            });
        }
        filters.push({
            name: '涉及层面',
            key: 'influenceLevel',
            type: 'select',
            typeProperty: {
                list: [
                    { label: '项目层面', value: 'INVESTIGATION_LEVEL' },
                    { label: '中心层面', value: 'SITE_LEVEL' },
                ]
            }
        }, 
        // {
        //     name: '重大事件风险等级',
        //     key: 'riskLevelId',
        //     type: 'select',
        //     typeProperty: {
        //         list: this.getOptions(config['RISK_LEVEL']),
        //     }
        // }, 
        {
            name: '主要责任方',
            key: 'mainResponsibleId',
            type: 'select',
            typeProperty: {
                list: this.getOptions(config['MAIN_RESPONSIBLE']),
            }
        }, {
            name: '报告人',
            key: 'reportUserName',
            type: 'input',
        }, {
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption,
            }
        }, {
            name: '执行业务线二级分类',
            key: 'secondLineName',
            type: 'select',
            typeProperty: {
                disabled: !lineOfBusiness,
                list: secondLineOption,
            }
        }, {
            name: '事件发生时间',
            key: 'eventHappenDate',
            type: 'rangePicker',
            typeProperty: {
                keys: ['eventHappenDateStart', 'eventHappenDateEnd'],
            }
        }, {
            name: '上报QA时间',
            key: 'reportToQaDate',
            type: 'rangePicker',
            typeProperty: {
                keys: ['reportToQaDateStart', 'reportToQaDateEnd'],
            }
        });
        return (
            <FilterBasic
                filters={filters}
                onChange={this.handleChange}
                {...rest}
            />
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/execute/importantEvent/Filter.js